// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SplatRouteImport } from './routes/$'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as AnalyticsRouteImport } from './routes/analytics'
import { Route as ApplyRouteImport } from './routes/apply'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as LeadsRouteImport } from './routes/leads'
import { Route as LoginRouteImport } from './routes/login'
import { Route as LpARouteImport } from './routes/lp-a'
import { Route as LpBRouteImport } from './routes/lp-b'
import { Route as LpCRouteImport } from './routes/lp-c'
import { Route as LpDRouteImport } from './routes/lp-d'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as ThankYouRouteImport } from './routes/thank-you'
import { Route as UsersRouteImport } from './routes/users'
import { Route as VslV3RouteImport } from './routes/vsl-v3'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as AdminAdSetsRouteImport } from './routes/admin.ad-sets'
import { Route as AdminAnalyticsRouteImport } from './routes/admin.analytics'
import { Route as AdminBookingsRouteImport } from './routes/admin.bookings'
import { Route as AdminGhlSyncRouteImport } from './routes/admin.ghl-sync'
import { Route as AdminLeadsRouteImport } from './routes/admin.leads'
import { Route as AdminPixelRouteImport } from './routes/admin.pixel'
import { Route as AdminSplitTestsRouteImport } from './routes/admin.split-tests'
import { Route as AdminSubmissionsRouteImport } from './routes/admin.submissions'
import { Route as AdminSurveyRouteImport } from './routes/admin.survey'
import { Route as AdminTagsRouteImport } from './routes/admin.tags'
import { Route as AdminUsersRouteImport } from './routes/admin.users'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const SplatRoute = SplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const AnalyticsRoute = AnalyticsRouteImport.update({
            id: '/analytics',path: '/analytics',getParentRoute: () => rootRouteImport
          })
const ApplyRoute = ApplyRouteImport.update({
            id: '/apply',path: '/apply',getParentRoute: () => rootRouteImport
          })
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => rootRouteImport
          })
const LeadsRoute = LeadsRouteImport.update({
            id: '/leads',path: '/leads',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const LpARoute = LpARouteImport.update({
            id: '/lp-a',path: '/lp-a',getParentRoute: () => rootRouteImport
          })
const LpBRoute = LpBRouteImport.update({
            id: '/lp-b',path: '/lp-b',getParentRoute: () => rootRouteImport
          })
const LpCRoute = LpCRouteImport.update({
            id: '/lp-c',path: '/lp-c',getParentRoute: () => rootRouteImport
          })
const LpDRoute = LpDRouteImport.update({
            id: '/lp-d',path: '/lp-d',getParentRoute: () => rootRouteImport
          })
const RegisterRoute = RegisterRouteImport.update({
            id: '/register',path: '/register',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const ThankYouRoute = ThankYouRouteImport.update({
            id: '/thank-you',path: '/thank-you',getParentRoute: () => rootRouteImport
          })
const UsersRoute = UsersRouteImport.update({
            id: '/users',path: '/users',getParentRoute: () => rootRouteImport
          })
const VslV3Route = VslV3RouteImport.update({
            id: '/vsl-v3',path: '/vsl-v3',getParentRoute: () => rootRouteImport
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminRoute
          })
const AdminAdSetsRoute = AdminAdSetsRouteImport.update({
            id: '/ad-sets',path: '/ad-sets',getParentRoute: () => AdminRoute
          })
const AdminAnalyticsRoute = AdminAnalyticsRouteImport.update({
            id: '/analytics',path: '/analytics',getParentRoute: () => AdminRoute
          })
const AdminBookingsRoute = AdminBookingsRouteImport.update({
            id: '/bookings',path: '/bookings',getParentRoute: () => AdminRoute
          })
const AdminGhlSyncRoute = AdminGhlSyncRouteImport.update({
            id: '/ghl-sync',path: '/ghl-sync',getParentRoute: () => AdminRoute
          })
const AdminLeadsRoute = AdminLeadsRouteImport.update({
            id: '/leads',path: '/leads',getParentRoute: () => AdminRoute
          })
const AdminPixelRoute = AdminPixelRouteImport.update({
            id: '/pixel',path: '/pixel',getParentRoute: () => AdminRoute
          })
const AdminSplitTestsRoute = AdminSplitTestsRouteImport.update({
            id: '/split-tests',path: '/split-tests',getParentRoute: () => AdminRoute
          })
const AdminSubmissionsRoute = AdminSubmissionsRouteImport.update({
            id: '/submissions',path: '/submissions',getParentRoute: () => AdminRoute
          })
const AdminSurveyRoute = AdminSurveyRouteImport.update({
            id: '/survey',path: '/survey',getParentRoute: () => AdminRoute
          })
const AdminTagsRoute = AdminTagsRouteImport.update({
            id: '/tags',path: '/tags',getParentRoute: () => AdminRoute
          })
const AdminUsersRoute = AdminUsersRouteImport.update({
            id: '/users',path: '/users',getParentRoute: () => AdminRoute
          })





const AdminRouteChildren = {
  AdminAdSetsRoute: AdminAdSetsRoute,AdminAnalyticsRoute: AdminAnalyticsRoute,AdminBookingsRoute: AdminBookingsRoute,AdminGhlSyncRoute: AdminGhlSyncRoute,AdminLeadsRoute: AdminLeadsRoute,AdminPixelRoute: AdminPixelRoute,AdminSplitTestsRoute: AdminSplitTestsRoute,AdminSubmissionsRoute: AdminSubmissionsRoute,AdminSurveyRoute: AdminSurveyRoute,AdminTagsRoute: AdminTagsRoute,AdminUsersRoute: AdminUsersRoute,AdminIndexRoute: AdminIndexRoute
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,SplatRoute: SplatRoute,AdminRoute: AdminRouteWithChildren,AnalyticsRoute: AnalyticsRoute,ApplyRoute: ApplyRoute,ForgotPasswordRoute: ForgotPasswordRoute,LeadsRoute: LeadsRoute,LoginRoute: LoginRoute,LpARoute: LpARoute,LpBRoute: LpBRoute,LpCRoute: LpCRoute,LpDRoute: LpDRoute,RegisterRoute: RegisterRoute,ResetPasswordRoute: ResetPasswordRoute,ThankYouRoute: ThankYouRoute,UsersRoute: UsersRoute,VslV3Route: VslV3Route
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)